import { handleActions } from 'redux-actions'
import {
  registerAppleHealthFail,
  registerAppleHealthSuccess,
  registerHealthConnectFail,
  registerHealthConnectSuccess,
  registerUserFail,
  registerUserSuccess,
  registerWithoutIntegrationFail,
  registerWithoutIntegrationSuccess,
  updateActivityDataFail,
  updateActivityDataSuccess,
} from './RegisterUserActions'

class State {
  lastUpdate: number | null = null
}

export const registerUser = handleActions<State, any>(
  {
    [String(registerUserSuccess)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(registerUserFail)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(updateActivityDataSuccess)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(updateActivityDataFail)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(registerHealthConnectSuccess)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(registerHealthConnectFail)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(registerWithoutIntegrationSuccess)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(registerWithoutIntegrationFail)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(registerAppleHealthSuccess)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
    [String(registerAppleHealthFail)]: (state: State): State => ({
      ...state,
      lastUpdate: new Date().getTime(),
    }),
  },
  new State(),
)

export { State as RegisterUserState }
